import React, { useContext, useState,useRef } from "react";
import AppContext from "../../utils/appContext";
import Slider from "react-slick";
import Loader from "../common/Loader";
import { useEffect } from "react";

const SliderList = ({
	imageArray,
	videoArray,
	imageName,
	setOpen = () => false,
	isPlaying,
	setIsPlaying,
	fromPopUp,
	from
}) => {
	const sliderRef = useRef(null)
	let context = useContext(AppContext);
	const [currentSlide, setCurrentSlide] = useState(context.activeSlide);
	const [videoKey, setVideoKey] = useState(0);
	const [autoplay, setAutoPlay] = useState('false');
	// Function to re-render the video tag
	const reRenderVideo = () => {
		setVideoKey((prevKey) => prevKey + 1);
	};
	const settings = {
		initialSlide: context.activeSlide, // set slide no, which needs to open first
		lazyLoad: 'progressive',
		ariaHidden: true,
		accessibility: false,
		adaptiveHeight: true,
		infinite:false,
		// onLazyLoad: slidesLoaded => {console.log('slideLoaded')},
		beforeChange: (pldIndex, newIndex) => {
			setCurrentSlide(newIndex);
			setIsPlaying(true);
			setAutoPlay(true);
			reRenderVideo();
		},
	};


	const openFullImage = (index, mediaType) => {
		setOpen(true);
		context.setActiveSlide(index); // add index of slide no in context var
	};

	let combineArr = [...imageArray, ...videoArray];
	combineArr = combineArr.filter((item) => item !== undefined);

	const [mediaLoaded, setMediaLoaded] = useState(false);
	const handleMediaLoad = () => {
		setMediaLoaded(true);		
	};
	const [width, setWidth] = useState(window.innerWidth);
	const isMobile = width <= 767;

	const donoting = () => {
		return false;
	}

	useEffect(() => {
		// After the slider has mounted and rendered, we can try to find and modify the dots
		const dots = sliderRef.current?.innerSlider?.dots;
		if (dots) {
			Array.from(dots.querySelectorAll('li button')).forEach(button => {
			button.setAttribute('tabindex', '-1');
			});
		}
		}, []);

	return (
		<Slider ref={sliderRef} {...settings}>
			{combineArr?.map((item, index) => {
				const isActive=index===currentSlide
				const checkImage = /\.(gif|jpg|jpeg|tiff|png)$/i.test(item);
				const mediaType = checkImage?"image":"video";
					return (
						<div className='posRelative' key={index} aria-hidden={!isActive}>
							{!mediaLoaded && <Loader />}
							{checkImage ? (
							<span
								role={isActive ? 'button' : undefined}
								tabIndex={isActive ? 0 : -1}
								className={`dBlock fullImgModal ${
									index !== 0 ? "innerImage" : ""
								}`}
								aria-describedby={isActive ? "media-modal" : undefined}
								onClick={() => !from?openFullImage(index, mediaType):null}
								onKeyPress={(event) => {
									if (isActive && event.key === "Enter") {
									event.preventDefault();
										openFullImage(index, mediaType);
									}
								}}
							>
								<img
									src={item}
									alt={`${imageName} ${index + 1}`}
									onLoad={handleMediaLoad}
									title='EnlargeImage'
									className={index !== 0 ? "innerImage" : ""}
								/>
							</span>
					):(
							<span
								className={`dBlock fullImgModal ${
									index !== 0 ? "innerImage" : ""
								}`}
								onClick={() => openFullImage(index, mediaType)}
								onKeyPress={(event) => {
									if (isActive && event.key === "Enter") {
										event.preventDefault();
										openFullImage(index, mediaType);
									}
								}}
							>
								<div style={{ width: "100%", height: "400px" }}>
									<video
										key={videoKey}
										style={{
											width: "100%",
											height: "100%",
										}}
										preload='auto'
										controlsList='nofullscreen nodownload noremoteplayback'
										autoPlay={autoplay}
										muted
										controls
										loop
										playsInline='playsinline'
										webkit-playsinline='true'
										x5-playsinline='true'
										tabIndex='-1'
										onLoadedData={handleMediaLoad}
										onClick={e => {fromPopUp === false ? e.target.pause() : donoting()}}
									>
										<source src={item} type='video/mp4' />
									</video>
								</div>
							</span>
					)}
					</div>
					)
				})}
		</Slider>
	);
};
export default SliderList;
